module.exports = __webpack_public_path__ + "static/media/pcd.af843cb5.PNG";